import AreaOfStudyTypeDomainService from "../../../Domain/AreaOfStudyType/AreaOfStudyType.service";
import makeAreaOfStudyLookup from "./AreaOfStudyLookup";
const SpecializationLookup = makeAreaOfStudyLookup(AreaOfStudyTypeDomainService.SPECIALIZATION_ID);
export default SpecializationLookup;
